import React from 'react';

import ProjectTeaser from './Teaser';
import ProjectDetail from './Detail';

const NodeProject = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <ProjectTeaser {...props} />;
  }

  return <ProjectDetail {...props} />;
};

export default NodeProject;
